import { Client, Contact } from '@models/profile/model';
import { CommonConstants } from '../constants/common.constant';

export class UserAccessUtil {
  public static getDivisionBasedDataFileAccessRoles(contact: Contact): boolean | undefined {
    return (contact && (contact.userAccessRoles?.some((r) => CommonConstants.divisionBasedDataFileAccessRoles && CommonConstants.divisionBasedDataFileAccessRoles.indexOf(r) >= 0)));
  }

  public static getDivisionBasedAddAndEnrollEmployeesAccessRoles(contact: Contact): boolean | undefined {
    return (contact && (contact.userAccessRoles?.some((r) => CommonConstants.divisionBasedAddAndEnrollEmployeesAccessRoles && CommonConstants.divisionBasedAddAndEnrollEmployeesAccessRoles.indexOf(r) >= 0)));
  }

  public static getDivisionBasedManageUsersAccessRoles(contact: Contact): boolean | undefined {
    return (contact && (contact.userAccessRoles?.some((r) => CommonConstants.divisionBasedManageUsersAccessRoles && CommonConstants.divisionBasedManageUsersAccessRoles.indexOf(r) >= 0)));
  }

  public static isSuperContact(client: Client, contact: Contact): boolean {
    return !!client && !!contact && (!client.divisionBasedAccess || contact.hasAccessToAllDivisions === true);
  }
}
